module.exports = __webpack_public_path__ + "static/media/Stoeberkurs_02.0408f4ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Stoeberkurs_02.jpg
// module id = 385
// module chunks = 0